import { exchangeAmountValidation } from '@funds/features/helpers/validation';
import { IWalletDetails } from '@market/interfaces/IWallet';
import { IUseExchangeFormPayload, TExchangeFormState } from './IExchangeForm';

const exchangeFormValidation = (
  values: TExchangeFormState['values'],
  payload: IUseExchangeFormPayload,
  userWallets: IWalletDetails[]
): TExchangeFormState['errors'] => {
  const errors: TExchangeFormState['errors'] = {};
  const requiredMessage = 'Required field.';

  switch (values.step) {
    case 1: {
      const userWallet = userWallets.find(el => el.currency === values.outcomeCurrency);
      const amountValidation = exchangeAmountValidation(values.outcomeAmount, userWallet, values.settings?.current);

      // Amount validation
      if (amountValidation) {
        errors.outcomeAmount = amountValidation;
      }

      if (payload.name === 'setMaximumAmount') {
        if (!payload.value) {
          errors.outcomeAmount = 'To set the maximum amount, first set the currency from the select options';
        }
      }

      // Select validation
      if (!values.selectCurrency) {
        errors.selectCurrency = requiredMessage;
      }

      // Exchange Rate
      if (!values.exchangeRate) {
        errors.exchangeRate = requiredMessage;
      }

      break;
    }
  }

  return errors;
};

export default exchangeFormValidation;
